import * as localforage from 'localforage'

/**
 * Small wrapper on top of localforage that allows to get a default value if not found
 */
export default class LocalStorage {
  store: typeof localforage
  storeKey: string

  /**
   * Get value from store
   */
  async get<T>(key: string, defaultValue: T): Promise<T> {
    const value: T | null = await this.store.getItem(key)
    return value === null ? defaultValue : value
  }

  /**
   * Save item to store
   */
  save<T>(key: string, value: T): Promise<T> {
    return this.store.setItem(key, value)
  }

  /**
   * Delete item from store
   */
  delete(key: string): Promise<void> {
    return this.store.removeItem(key)
  }

  constructor(storeKey: string) {
    this.storeKey = storeKey
    this.store = localforage.createInstance({
      name: storeKey,
    })
  }
}
